import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { Transaction, TransactionState } from "src/types/transaction.types";

const initialState: TransactionState = {
  createTransaction: {
    loading: false,
    data: null,
    error: null,
  },
  editTransaction: {
    loading: false,
    data: null,
    error: null,
  },
  transactionsList: {
    loading: false,
    data: null,
    error: null,
  },
  transactionDetails: {
    loading: false,
    data: null,
    error: null,
  },
};

const transactionSlice = createSlice({
  name: "transaction",
  initialState,
  reducers: {
    createTransactionRequest: (state, action: PayloadAction<any>) => {
      state.createTransaction.loading = true;
      state.createTransaction.data = null;
      state.createTransaction.error = null;
    },
    createTransactionSuccess: (state, action: PayloadAction<any>) => {
      state.createTransaction.loading = false;
      state.createTransaction.data = action.payload;
      state.createTransaction.error = null;
    },
    createTransactionError: (state, action: PayloadAction<string>) => {
      state.createTransaction.loading = false;
      state.createTransaction.data = null;
      state.createTransaction.error = action.payload;
    },
    resetCreateTransaction: (state) => {
      state.createTransaction.loading = false;
      state.createTransaction.data = null;
      state.createTransaction.error = null;
    },

    // edit transaction actions
    editTransactionRequest: (
      state,
      action: PayloadAction<{ id: string; data: any }>
    ) => {
      state.editTransaction.loading = true;
      state.editTransaction.data = null;
      state.editTransaction.error = null;
    },
    editTransactionSuccess: (state, action: PayloadAction<any>) => {
      state.editTransaction.loading = false;
      state.editTransaction.data = action.payload;
      state.editTransaction.error = null;
    },
    editTransactionError: (state, action: PayloadAction<string>) => {
      state.editTransaction.loading = false;
      state.editTransaction.data = null;
      state.editTransaction.error = action.payload;
    },
    resetEditTransaction: (state) => {
      state.editTransaction.loading = false;
      state.editTransaction.data = null;
      state.editTransaction.error = null;
    },

    // get transaction list actions
    getTransactionListRequest: (
      state,
      action: PayloadAction<{
        page: number;
        limit: number;
        search?: string;
        status?: string;
      }>
    ) => {
      state.transactionsList.loading = true;
      state.transactionsList.data = null;
      state.transactionsList.error = null;
    },
    getTransactionListSuccess: (state, action: PayloadAction<any>) => {
      state.transactionsList.loading = false;
      state.transactionsList.data = action.payload;
      state.transactionsList.error = null;
    },
    getTransactionListError: (state, action: PayloadAction<string>) => {
      state.transactionsList.loading = false;
      state.transactionsList.data = null;
      state.transactionsList.error = action.payload;
    },

    // get transaction details actions
    getTransactionDetailsRequest: (state, action: PayloadAction<string>) => {
      state.transactionDetails.loading = true;
      state.transactionDetails.data = null;
      state.transactionDetails.error = null;
    },
    getTransactionDetailsSuccess: (state, action: PayloadAction<any>) => {
      state.transactionDetails.loading = false;
      state.transactionDetails.data = action.payload?.data || action.payload;
      state.transactionDetails.error = null;
    },
    getTransactionDetailsError: (state, action: PayloadAction<string>) => {
      state.transactionDetails.loading = false;
      state.transactionDetails.data = null;
      state.transactionDetails.error = action.payload;
    },
    resetTransactionDetails: (state) => {
      state.transactionDetails.loading = false;
      state.transactionDetails.data = null;
      state.transactionDetails.error = null;
    },
  },
});

export const {
  // create transaction actions
  createTransactionRequest,
  createTransactionSuccess,
  createTransactionError,
  resetCreateTransaction,

  // edit transaction actions
  editTransactionRequest,
  editTransactionSuccess,
  editTransactionError,
  resetEditTransaction,

  // get transactions list actions
  getTransactionListRequest,
  getTransactionListSuccess,
  getTransactionListError,

  // get transaction details actions
  getTransactionDetailsRequest,
  getTransactionDetailsSuccess,
  getTransactionDetailsError,
  resetTransactionDetails,
} = transactionSlice.actions;
export default transactionSlice.reducer;
